// removed by extract-text-webpack-plugin
module.exports = {"thick":"Divider__thick___B4j0X","scaled":"Divider__scaled___3U1Ax"};